interface Step {
  active: boolean
  href?: string
  onClick?: () => void
}

interface Props {
  steps: Step[]
  label: string
  countLabel: string
}

export function OnboardingStepper({ steps, label }: Props) {
  return (
    <div className="mb-10">
      <div className="mb-3 text-[12px] font-medium tracking-wide" style={{ color: '#8B9BB4' }}>
        {label}
      </div>
      <div className="flex gap-1.5 w-full">
        {steps.map((step, i) => {
          const style = {
            height: 3,
            backgroundColor: step.active ? 'rgba(255,255,255,0.92)' : 'rgba(255,255,255,0.1)',
            border: 'none',
            padding: 0,
          }
          if (step.onClick) {
            return (
              <button
                key={i}
                onClick={step.onClick}
                className="flex-1 rounded-full cursor-pointer hover:opacity-70 transition-opacity"
                style={style}
              />
            )
          }
          return <div key={i} className="flex-1 rounded-full transition-colors duration-300" style={style} />
        })}
      </div>
    </div>
  )
}
